import React, { forwardRef } from 'react';
import Typography from '../Typography';
import { LinkProps } from './types';

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      color = { default: 'linkPrimary' },
      decoration = { default: 'underline' },
      outlineColor = {
        focusVisible: 'grey_1200',
      },
      outlineOffset = {
        focusVisible: 'sm',
      },
      outlineWidth = {
        focusVisible: 'md',
      },
      outlineStyle = { focusVisible: 'solid' },
      fontWeight,
      children,
      href,
      target = '_self',
      disabled,
      tabIndex,
      pointerEvents,
      ...restProps
    }: LinkProps,
    ref
  ) => (
    <Typography
      {...restProps}
      as="a"
      decoration={disabled ? 'none' : decoration}
      color={disabled ? 'grey_800' : color}
      pointerEvents={disabled ? 'none' : pointerEvents}
      tabIndex={disabled ? -1 : tabIndex}
      outlineOffset={outlineOffset}
      outlineWidth={outlineWidth}
      outlineColor={outlineColor}
      target={target}
      href={href}
      ref={ref}
      fontWeight={fontWeight}
      outlineStyle={outlineStyle}
    >
      {children}
    </Typography>
  )
);

Link.displayName = 'Link';

export default Link;
